import React, { createContext, useState, useEffect, useContext } from 'react';
import { login as apiLogin, logout as apiLogout } from '../services/authService';

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check for user in localStorage on initial load
    const user = JSON.parse(localStorage.getItem('user'));
    setCurrentUser(user);
    setLoading(false);
  }, []);

  // Login function
  async function login(email, password) {
    try {
      const response = await apiLogin(email, password);
      setCurrentUser(response.user);
      localStorage.setItem('user', JSON.stringify(response.user));
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Logout function
  function logout() {
    apiLogout();
    setCurrentUser(null);
    localStorage.removeItem('user');
  }

  const value = {
    currentUser,
    login,
    logout,
    isAuthenticated: !!currentUser
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
} 